import { TICKET_SERVICE_DETAILS } from './ticket-service-details.i18n';

/** Shared translator entries for the ticket-service preview. */
export const TICKET_SERVICE_STRINGS: Record<string, [string, string, string]> = {
  ...TICKET_SERVICE_DETAILS,
  'ts.preview': [
    '介面預覽 · 示意資料，不會實際退票',
    'UI preview · Sample data; no actual refunds',
    '画面プレビュー・サンプルデータ（返金は行いません）',
  ],
  'ts.scenes': ['切換預覽畫面', 'Preview screen', 'プレビュー画面'],
  'ts.service': ['票券服務', 'Ticket services', 'チケットサービス'],
  'ts.flight': ['航班查詢', 'My sailing', '便の確認'],
  'ts.flightDesc': [
    '掃描已購票券，查看航班時間與登船資訊。',
    'Scan your ticket for departure and boarding details.',
    'チケットをスキャンして出発時刻と乗船情報を確認。',
  ],
  'ts.refund': ['辦理退票', 'Request a refund', '払い戻し申請'],
  'ts.refundDesc': [
    '先確認資格與退款金額，再決定是否申請。',
    'Review eligibility and the amount before you decide.',
    '条件と金額を確認してから申請できます。',
  ],
  'ts.progress': ['退票進度', 'Refund progress', '払い戻し状況'],
  'ts.progressDesc': [
    '查看已申請退票的處理情形。',
    'Check an existing refund request.',
    '申請済みの払い戻し状況を確認。',
  ],
  'ts.backService': ['返回查詢票券', 'Back to ticket services', 'チケットサービスに戻る'],
  'ts.otherTicket': ['查詢其他票券', 'Look up another ticket', '別のチケットを照会'],
  'ts.scanOriginal': ['掃描原票券', 'Scan original ticket', '元のチケットをスキャン'],
  'ts.scanHint': [
    '將 QR Code 對準掃描區',
    'Align the QR code with the scanner',
    'QRコードを読み取り部にかざしてください',
  ],
  'ts.brightness': [
    '保持票券平整，手機請調高亮度',
    'Keep the ticket flat and brighten your phone screen',
    'チケットを平らにし、画面を明るくしてください',
  ],
  'ts.simulateScan': ['模擬掃描票券', 'Simulate ticket scan', 'スキャンを体験'],
  'ts.scanNote': [
    '每次查詢一張票券。掃描只查詢資訊，不會完成報到或將票券標記為已使用。',
    'One ticket at a time. Looking up a ticket does not check it in or mark it as used.',
    '一度に1枚を照会します。照会では受付や使用済みへの変更は行いません。',
  ],
  'ts.refundScanNote': [
    '每次辦理一張票券。掃描不會直接退票，確認金額並同意後才會送出申請。',
    'One ticket at a time. Scanning does not submit a refund; review and agree first.',
    '一度に1枚。スキャンだけでは返金されません。金額と同意の確認が必要です。',
  ],
  'ts.backScan': ['返回掃描', 'Back to scanner', 'スキャンに戻る'],
  'ts.query': ['查詢票券', 'Look up ticket', 'チケットを照会'],
  'ts.reference': ['申請編號', 'Refund reference', '申請番号'],
  'ts.trip': ['航程', 'Voyage', '航路'],
  'ts.departure': ['出發時間', 'Departure', '出発時刻'],
  'ts.type': ['票種／張數', 'Ticket / quantity', '券種／枚数'],
  'ts.one': ['1 張', '1 ticket', '1枚'],
  'ts.ticketNumber': ['票號', 'Ticket number', 'チケット番号'],
  'ts.duration': ['航程時間', 'Duration', '所要時間'],
  'ts.minutes': ['約 {count} 分鐘', 'About {count} minutes', '約{count}分'],
  'ts.sailingState': ['航班狀態', 'Sailing status', '運航状況'],
  'ts.normal': ['正常開航', 'Scheduled to sail', '運航予定'],
  'ts.weather': ['天候停航', 'Cancelled due to weather', '天候による欠航'],
  'ts.valid': ['票券有效 · 尚未使用', 'Valid ticket · Not used', '有効・未使用'],
  'ts.boardingNote': [
    '此頁僅供查詢，登船報到請至登船口由現場人員協助。',
    'This is an information page. Please check in with staff at the boarding gate.',
    'この画面は照会専用です。乗船受付は乗船口のスタッフへ。',
  ],
  'ts.viewAmount': ['查看退票金額', 'View refund amount', '払い戻し金額を見る'],
  'ts.arrangements': ['查看退票安排', 'View refund arrangements', '払い戻しの案内を見る'],
  'ts.paid': ['單張實付金額', 'Amount paid for this ticket', '1枚の支払額'],
  'ts.deduction': ['退票扣除費用', 'Refund deductions', '払い戻し控除額'],
  'ts.amount': ['預估退款金額', 'Estimated refund', '払い戻し予定額'],
  'ts.refundAmount': ['退款金額', 'Refund amount', '返金額'],
  'ts.oldAmount': ['原預估退款', 'Previous estimate', '前回の予定額'],
  'ts.newAmount': ['最新退款金額', 'Updated refund amount', '最新の返金額'],
  'ts.reason': ['退票原因', 'Reason for refund', '払い戻し理由'],
  'ts.reasonChange': ['行程變更', 'Plans changed', '予定変更'],
  'ts.reasonDuplicate': ['重複購買', 'Duplicate purchase', '重複購入'],
  'ts.reasonOther': ['其他原因', 'Other reason', 'その他'],
  'ts.agree': [
    '我已確認退票資訊，了解受理後此票無法登船。款項將退回原付款方式。',
    'I have reviewed the refund details. Once accepted, this ticket cannot be used for boarding. Payment returns to the original method.',
    '内容を確認しました。受付後はこの券で乗船できません。返金は元の決済方法で行われます。',
  ],
  'ts.keep': ['保留票券', 'Keep ticket', 'チケットを保持'],
  'ts.submit': ['確認申請退票', 'Confirm refund request', '払い戻しを申請'],
  'ts.submitNew': ['同意新金額並申請', 'Accept new amount and apply', '新しい金額に同意して申請'],
  'ts.unchanged': [
    '尚未依新金額建立退票，票券仍維持原狀態。',
    'No refund at the new amount has been requested. The ticket is unchanged.',
    '新しい金額での申請はまだ行われていません。',
  ],
  'ts.ticketState': ['票券狀態', 'Ticket status', 'チケットの状態'],
};
